module.exports = __webpack_public_path__ + "static/media/driling2017a.ebc73b66.png";